// @flow

import {
  SYSTEM_USERS_SET,
  SYSTEM_USERS_ADD,
  SYSTEM_USERS_UPDATE,
  SYSTEM_USERS_REMOVE,
} from "../actions"

const handleSystemUserUpdate = ( state: any, action: any ) => {
  const newUserId = action.user.id
  const filteredUsers = state.filter( user => user.id !== newUserId )
  return [ action.user, ...filteredUsers ]
}

export default ( state: any = [], action: any ) => {
  switch ( action.type ) {
  case SYSTEM_USERS_ADD:
    return [ action.user, ...state ]
  case SYSTEM_USERS_SET:
    return action.users
  case SYSTEM_USERS_UPDATE:
    return handleSystemUserUpdate( state, action )
  case SYSTEM_USERS_REMOVE:
    return state.filter( user => user.id !== action.id )
  default:
    return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/systemUsers.jsx